export class MedicalRecordSummaryType {
    id = null;
    name = null;
    code = null;
    description = null;
}